export const iconFontAwesomeMedicalHealthTeethOpen = (
	<i className="fa-solid fa-teeth-open"></i>
);
